import { authenticatedFastApiAxiosInstance } from "@/lib/data/http";
import type { APIResponse } from "@/lib/types";
import type { FirmReferralDirectoryEntry } from "./referral-profile";

export type PartnerFirm = {
  id: string;
  connectedFirm: FirmReferralDirectoryEntry;
  requestId: string;
  status: "ACTIVE" | "ARCHIVED";
  archivedAt: string | null;
  dateCreated: string;
  dateModified: string;
};
export type PartnerRequestStatus =
  | "PENDING"
  | "ACCEPTED"
  | "DECLINED"
  | "CANCELED";
export type PartnerRequestDirection = "INCOMING" | "OUTGOING";
export type PartnerRequest = {
  id: string;
  requestingFirmId: string;
  receivingFirmId: string;
  direction: PartnerRequestDirection;
  status: PartnerRequestStatus;
  counterpartyFirm: FirmReferralDirectoryEntry;
  respondedAt: string | null;
  canceledAt: string | null;
  dateCreated: string;
  dateModified: string;
};
export type RespondToPartnerRequestInput = {
  requestId: string;
  action: "accept" | "decline" | "cancel";
};

const referralConnectionRequestsRoute =
  "/firms/v2/referral-connection-requests";
const referralNetworkConnectionsRoute =
  "/firms/v2/referral-network-connections";

export const listPartnerFirms = (cursor?: string) =>
  authenticatedFastApiAxiosInstance
    .get<APIResponse<PartnerFirm[]>>(referralNetworkConnectionsRoute, {
      params: { cursor, limit: 24 },
    })
    .then((res) => res.data);
export const listPartnerRequests = (
  direction: PartnerRequestDirection,
  cursor?: string,
) =>
  authenticatedFastApiAxiosInstance
    .get<APIResponse<PartnerRequest[]>>(referralConnectionRequestsRoute, {
      params: { direction, status: "PENDING", cursor, limit: 24 },
    })
    .then((res) => res.data);
export const createPartnerRequest = (receivingFirmId: string) =>
  authenticatedFastApiAxiosInstance
    .post<APIResponse<PartnerRequest>>(referralConnectionRequestsRoute, {
      receivingFirmId,
    })
    .then((res) => res.data);
export const respondToPartnerRequest = ({
  requestId,
  action,
}: RespondToPartnerRequestInput) =>
  authenticatedFastApiAxiosInstance
    .post<
      APIResponse<PartnerRequest & { connection?: PartnerFirm }>
    >(`${referralConnectionRequestsRoute}/${requestId}/${action}`)
    .then((res) => res.data);

export const removePartnerFirm = (connectionId: string) =>
  authenticatedFastApiAxiosInstance
    .delete<
      APIResponse<PartnerFirm>
    >(`${referralNetworkConnectionsRoute}/${connectionId}`)
    .then((res) => res.data);
